import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { SearchTarget } from '@woolworthsnz/styleguide';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class SearchListItemsParamGuard {
	constructor(private router: Router) {}

	canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		const target = route.data['target'];
		if (target !== SearchTarget.SKUs) {
			return true;
		}

		if (route.queryParams.search === undefined) {
			return true;
		}

		// If we are coming from an external link to the SKUs page the list will come in the `search` param, but we want it in a `skus` param, so we swap here
		const queryParams = { ...route.queryParams };
		queryParams.skus = queryParams.search;
		delete queryParams.search;

		const urlTree = this.router.parseUrl(state.url);
		urlTree.queryParams = queryParams;
		return urlTree;
	}
}
